/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Query_Logger_DescInputs */

const en_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log all database queries to the console`)
};

const ar_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل جميع استعلامات قاعدة البيانات في الطرفية`)
};

const bn_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব ডেটাবেস কুয়েরি কনসোলে লগ করুন`)
};

const de_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokollieren Sie alle Datenbankabfragen an der Konsole`)
};

const es_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra todas las consultas de la base de datos en la consola`)
};

const fr_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigner toutes les requêtes de base de données sur la console`)
};

const pt_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra todas as consultas do banco de dados no console`)
};

const zh_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将所有数据库查询记录到控制台`)
};

const tr_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm veritabanı sorgularını konsola kaydedin`)
};

const ru_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записывать все запросы к базе данных в консоль`)
};

const pl_dev_item_query_logger_desc = /** @type {(inputs: Dev_Item_Query_Logger_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestruj wszystkie zapytania do bazy danych w konsoli`)
};

/**
* | output |
* | --- |
* | "Log all database queries to the console" |
*
* @param {Dev_Item_Query_Logger_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_query_logger_desc = /** @type {((inputs?: Dev_Item_Query_Logger_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Query_Logger_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_query_logger_desc(inputs)
	if (locale === "bn") return bn_dev_item_query_logger_desc(inputs)
	if (locale === "de") return de_dev_item_query_logger_desc(inputs)
	if (locale === "es") return es_dev_item_query_logger_desc(inputs)
	if (locale === "fr") return fr_dev_item_query_logger_desc(inputs)
	if (locale === "pt") return pt_dev_item_query_logger_desc(inputs)
	if (locale === "zh") return zh_dev_item_query_logger_desc(inputs)
	if (locale === "tr") return tr_dev_item_query_logger_desc(inputs)
	if (locale === "ru") return ru_dev_item_query_logger_desc(inputs)
	if (locale === "pl") return pl_dev_item_query_logger_desc(inputs)
	return en_dev_item_query_logger_desc(inputs)
});